<template>
  <div class="content">
    <div class="page-title flex align-center just-content-between">
      <div class="flex">
        <p>{{ pageTitle }}</p>
        <p class="u-ml30">{{ tabs + 1 }} / {{ tabsMax + 1 }}</p>
      </div>
      <div class="flex align-center u-ml40 u-mr20" style="font-size: 14px">
        <span class="icon">
          <font-awesome-icon icon="user" size="2x"></font-awesome-icon>
        </span>
        <p class="u-mr10 u-ml5 u-mb0">{{ schoolYear }}</p>
        <p class="u-mb0">{{ childName }}</p>
      </div>
    </div>

    <OrganismsAnchorLink
      :anchorLinks="useDefine.defineObject.NAV_BASIC_SURVEY_2_ANCHORS_ARRAY"
      @goToPageAnchor="goToPage"
    />

    <p class="prohibited-text">
      ※ブラウザの戻るボタン/再読み込みは使用しないでください。<br />入力中のデータが正しく処理されません。
    </p>
    <div class="form-wrap">
      <div class="tab -0" v-if="tabs === 0">
        <section class="form-section">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="2-1" label="記入者情報" />
            <atoms-input-text
              label="記入者"
              type="text"
              placeholder="記入者"
              inputmode="text"
              :required="false"
              v-model="formData.writer"
              setKey="writer"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-select
              label="聞き取り相手"
              v-model="formData.interviewsOpponent"
              setKey="interviewsOpponent"
              :options="useDefine.defineObject.INTERVIEWSOPPONENT_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-text
              label="その他"
              type="text"
              placeholder="その他"
              inputmode="text"
              :required="false"
              v-model="formData.interviewsOpponentOtherwise"
              setKey="interviewsOpponentOtherwise"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-select-date
              :date="formData.interviewsDate"
              label="聞き取り日"
              set-key="interviewsDate"
              @input-value="handleInputValue"
            />
          </div>
        </section>
      </div>
      <div class="tab -1" v-if="tabs === 1">
        <section class="form-section">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="2-2" label="健診での指摘" />
            <atoms-input-textarea
              label="1歳6ヶ月ごろの様子"
              placeholder="1歳6ヶ月ごろの様子"
              :required="false"
              v-model="
                formData.earlyChildhoodMedicalExaminationPointedOutFirstYearsOld
              "
              setKey="earlyChildhoodMedicalExaminationPointedOutFirstYearsOld"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              label="3歳ごろの様子"
              placeholder="3歳ごろの様子"
              :required="false"
              v-model="
                formData.earlyChildhoodMedicalExaminationPointedOutThreeYearsOld
              "
              setKey="earlyChildhoodMedicalExaminationPointedOutThreeYearsOld"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="2-3" label="生育の様子" />
            <atoms-input-select
              label="友達遊び"
              v-model="formData.earlyChildhoodPlayMate"
              setKey="earlyChildhoodPlayMate"
              :options="useDefine.defineObject.PLAYMATE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              :label="`遊びの特徴`"
              placeholder="遊びの特徴"
              :required="false"
              v-model="formData.earlyChildhoodFeaturesOfPlay"
              setKey="earlyChildhoodFeaturesOfPlay"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="`保育園・幼稚園`"
              placeholder="保育園・幼稚園"
              :required="false"
              v-model="formData.earlyChildhoodNurserySchoolOrKindergarten"
              setKey="earlyChildhoodNurserySchoolOrKindergarten"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="`訓練会など`"
              placeholder="訓練会など"
              :required="false"
              v-model="formData.earlyChildhoodTrainingMeeting"
              setKey="earlyChildhoodTrainingMeeting"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="`就学前健診での指摘`"
              placeholder="就学前健診での指摘"
              :required="false"
              v-model="
                formData.earlyChildhoodPreschoolMedicalExaminationPointedOut
              "
              setKey="earlyChildhoodPreschoolMedicalExaminationPointedOut"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="
                `相談歴・判定歴\n（相談または判定機関・時期・指摘事項・その他）`
              "
              placeholder="相談または判定機関・時期・指摘事項・その他"
              :required="false"
              v-model="
                formData.earlyChildhoodConsultationAndDeterminationHistory
              "
              setKey="earlyChildhoodConsultationAndDeterminationHistory"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>
      <div class="tab -2" v-if="tabs === 2">
        <section class="form-section">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="2-4" label="学齢期" />
            <atoms-input-textarea
              :label="`通学歴・状況\n（個別級・普通級の別、通学状況等）`"
              placeholder="個別級・普通級の別、通学状況等"
              :required="false"
              v-model="formData.schoolAgeSchoolHistoryOrSituation"
              setKey="schoolAgeSchoolHistoryOrSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="`その他（施設利用等）`"
              placeholder="その他（施設利用等）"
              :required="false"
              v-model="formData.schoolAgeOther"
              setKey="schoolAgeOther"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="
                `相談歴・判定歴\n（相談または判定機関・時期・指摘事項・その他）`
              "
              placeholder="相談または判定機関・時期・指摘事項・その他"
              :required="false"
              v-model="formData.schoolAgeConsultationAndDeterminationHistory"
              setKey="schoolAgeConsultationAndDeterminationHistory"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="2-5" label="学齢期以降～現在の様子" />
            <atoms-input-textarea
              :label="`通所先・就労先`"
              placeholder="通所先・就労先"
              :required="false"
              v-model="formData.currentStatusFromSchoolAgeDayCareAndWorking"
              setKey="currentStatusFromSchoolAgeDayCareAndWorking"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="
                `相談歴・判定歴\n（相談または判定機関・時期・指摘事項・その他）`
              "
              placeholder="相談または判定機関・時期・指摘事項・その他"
              :required="false"
              v-model="
                formData.currentStatusFromSchoolAgeConsultationAndDeterminationHistory
              "
              setKey="currentStatusFromSchoolAgeConsultationAndDeterminationHistory"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>
      <div class="tab -3" v-if="tabs === 3">
        <section class="form-section">
          <atoms-label label="学齢期" class="u-mb15" />

          <atoms-input-textarea
            :label="`【通学歴・状況】\n（個別級・普通級の別、通学状況等）`"
            placeholder="個別級・普通級の別、通学状況等"
            :required="false"
            v-model="formData.schoolAgeSchoolHistoryOrSituation"
            setKey="schoolAgeSchoolHistoryOrSituation"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-textarea
            :label="`【その他（施設利用等）】`"
            placeholder="その他（施設利用等）"
            :required="false"
            v-model="formData.schoolAgeOther"
            setKey="schoolAgeOther"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-textarea
            :label="
              `【相談歴・判定歴】\n（相談または判定機関・時期・指摘事項・その他）`
            "
            placeholder="相談または判定機関・時期・指摘事項・その他"
            :required="false"
            v-model="formData.schoolAgeConsultationAndDeterminationHistory"
            setKey="schoolAgeConsultationAndDeterminationHistory"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </section>

        <section class="form-section">
          <atoms-label label="学齢期以降～現在の様子" class="u-mb15" />

          <atoms-input-textarea
            :label="`【通所先・就労先】`"
            placeholder="通所先・就労先"
            :required="false"
            v-model="formData.currentStatusFromSchoolAgeDayCareAndWorking"
            setKey="currentStatusFromSchoolAgeDayCareAndWorking"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-textarea
            :label="
              `【相談歴・判定歴】\n（相談または判定機関・時期・指摘事項・その他）`
            "
            placeholder="相談または判定機関・時期・指摘事項・その他"
            :required="false"
            v-model="
              formData.currentStatusFromSchoolAgeConsultationAndDeterminationHistory
            "
            setKey="currentStatusFromSchoolAgeConsultationAndDeterminationHistory"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </section>
      </div>

      <div class="check_button_wrap prev_and_next">
        <div class="prev">
          <atoms-note-button
            v-if="tabs > tabsMin"
            buttonText="前の項目へ"
            @confirm="handlePrevTabs"
          />
        </div>
        <div class="next">
          <atoms-note-button
            v-if="tabs < tabsMax"
            buttonText="次の項目へ"
            @confirm="handleNextTabs"
          />
        </div>
      </div>
    </div>
    <div class="form-tabs" v-if="nextPageTitle">
      <atoms-note-button
        :buttonText="`${nextPageTitle}へ`"
        @confirm="handleUpdateFormTab"
      />
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
import formUtils from '@/lib/formUtils/form-utils'
import OrganismsAnchorLink from '@/components/organisms/basicSurvey/OrganismsAnchorLink.vue'
export default {
  components: {
    OrganismsAnchorLink,
  },
  data() {
    return {
      tabsMin: 0,
      tabsMax: 2,
      tabs: 0,
      // formの選択肢
      useDefine: { defineObject: defineObject },
      // emit対象のformデータ
      formData: {
        createdDate: '',
        lastName: '',
        firstName: '',
        writer: '',
        interviewsOpponent: '',
        interviewsOpponentOtherwise: '',
        interviewsDate: '',
        // 乳幼児期
        earlyChildhoodEpilepsy: '',
        earlyChildhoodearlyChildhoodInitialAge: '',
        earlyChildhoodearlyChildhoodInitialMonths: '',
        earlyChildhoodSedentary: '',
        earlyChildhoodWalkFirstTime: '',
        earlyChildhoodFirstWords: '',
        earlyChildhoodMedicalExaminationPointedOutFirstYearsOld: '',
        earlyChildhoodMedicalExaminationPointedOutThreeYearsOld: '',
        earlyChildhoodPlayMate: '',
        earlyChildhoodFeaturesOfPlay: '',
        earlyChildhoodNurserySchoolOrKindergarten: '',
        earlyChildhoodTrainingMeeting: '',
        earlyChildhoodPreschoolMedicalExaminationPointedOut: '',
        earlyChildhoodConsultationAndDeterminationHistory: '',
        // 学齢期
        schoolAgeSchoolHistoryOrSituation: '',
        schoolAgeOther: '',
        schoolAgeConsultationAndDeterminationHistory: '',
        // 学齢期以降～現在の様子
        currentStatusFromSchoolAgeDayCareAndWorking: '',
        currentStatusFromSchoolAgeConsultationAndDeterminationHistory: '',
      },
    }
  },
  props: {
    propsFormData: {
      type: Object,
      required: true,
    },
    setObjectKey: {
      type: String,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    nextPageTitle: {
      type: String,
      required: false,
    },
    childName: {
      type: String,
      required: false,
    },
    schoolYear: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleUpdateValue(setKey, setVal) {
      this.formData[setKey] = setVal
      this.$emit('input-emit', this.setObjectKey, setKey, setVal)
    },
    handlePrevTabs() {
      this.handleSmoothScroll()
      this.tabs--
    },
    handleNextTabs() {
      this.handleSmoothScroll()
      this.tabs++
    },
    handleSmoothScroll() {
      this.$smoothScroll({
        scrollTo: document.getElementById('app'), // scrollTo is also allowed to be number
      })
    },
    handleUpdateFormTab() {
      this.$emit('click-tab-switch', this.setObjectKey)
    },
    handleInputValue(value, key) {
      const date = `${value.getFullYear()}-${value.getMonth() +
        1}-${value.getDate()}`
      this.formData[key] = date
      this.$emit('input-emit', this.setObjectKey, key, date)
    },
    goToPage(tab) {
      this.tabs = tab
    },
  },
  mounted() {
    Object.keys(this.formData).forEach(key => {
      if (this.propsFormData[key]) {
        this.formData[key] = this.propsFormData[key]
      }

      this.handleUpdateValue(key, this.formData[key])
    })

    if (!this.formData.createdDate) {
      this.formData.createdDate = formUtils.handleSetJapaneseCalendar(
        new Date(),
        '',
        'none'
      )
      this.handleUpdateValue('createdDate', this.formData.createdDate)
    }
  },
}
</script>
<style lang="scss" scoped>
.form-tabs {
  margin: 0 auto;
  max-width: 460px;
  button {
    width: 100%;
  }
}
</style>
